<template>
  <div id="psiko-petunjuk-dan-informasi">
    <v-container fluid>
      <v-layout>
        <v-flex md12 class="text-sm-center">
          <div
            class="headline"
            style=" text-decoration: underline;margin-top:10px;"
          >INFORMASI PENTING TENTANG PETUNJUK MENGIKUTI PSIKOTES</div>
        </v-flex>
      </v-layout>

       <v-layout>
        <v-flex md12>
          <div
            class="title"
            style="margin-top:20px;margin-left:20px;"
          >Pengertian dan pemahaman mengikuti program Psikotes</div>
          <p
            class="body-1"
            style="margin-top:10px;margin-left:20px;margin-right:5px;"
          >Psikotes adalah program tes psikologi yang mengunakan baterai tes alat ukur psikologi yang sudah terstandart dan teruji kevaliatannya meliputi macam-macam tes kecerdasan kognitif (IQ), tes kepribadian meliputi (tes perkembangan karakter, tes EQ, tes Sc.Q, tes SQ), tes bakat dan minat dll. yang disesuakan dan dikondisikan dengan tingkat usia, pendidikan, pengetahuan dan latar belakang budaya secara umum dengan diperuntukkan pada nilai-2 kebutuhan yang diharapkan dan dinginkan.</p>
        </v-flex>
      </v-layout>


      <v-layout align-center justify-center>
        <v-flex md12>
          <div class="title" style="margin-top:20px;margin-left:15px;">Tujuan Psikotes</div>
          <p
            class="body-1"
            style="margin-top:10px;margin-left:20px;margin-right:5px;"
          >Tujuan pengukuran psikotes untuk mengukur tingkat macam-macam potensi kecerdasan seseorang secara umum, secara khusus dan secara keseluruhan dari IQ, EQ, Sc.Q, SQ didukung nilai karakter kepribadian dan kemampuan khusus dari bakat dan minat yang berkembang sampai saat ini dari pengaruh heriditas atau bawaan dan dipengaruhi oleh factor berkembangnya pengetahuan, latihan-latihan dan pengalaman seseorang dalam menyelesaikan tugas-2 dan permasalahan yang dihadapi.</p>
        </v-flex>
      </v-layout>



      <v-layout align-center justify-center>
        <v-flex md12>
          <div
            class="title"
            style="margin-top:20px;margin-left:15px;"
          >Manfaat dan kegunaan mengikuti Psikotes</div>
          <p
            style="margin-top:10px;margin-left:20px;margin-right:5px;"
          >Manfaat Pengukuran Psikotes Untuk mengetahui nilai kelebihan dan kekurangan yang dimiliki setiap orang di lihat dari semua aspek psikologis dimulai dari tingkat semua kecerdasan secara keseluruhan dan saling mendukung diantaranya mulai dari kecerdasan kognitif (IQ), afektif ( EQ,SQ,Sc.Q ), CQ dan Bakat-minat. Secara khusus dibidang pendidikan pemetaan kemampuan siswa, Membuat predeksi hasil belajar, pemetaan tentang jurusan dan kelanjutan studi berdasar kemampuannya, membuat motivasi belajar dan pengembangan potensi prestasinya, membantu mengatasi permasalahan dari sebab-sebab tingkah laku yang menyimpang. Dalam bidang industri psikotes untuk proses rekrutmen pegawai, kebutuhan promosi dan mutasi, assesmen pegawai, sebagai dasar merumuskan bentuk pelatihan pegawai atau training, dll. Dalam bidang psikologi klinis dipakai untuk menganalisan dan mendiagnosa klien untuk membuat terapis klinis.</p>
        </v-flex>
      </v-layout>

      <v-layout align-center justify-center>
        <v-flex md12>
          <div
            class="title"
            style="margin-top:20px;margin-left:15px;"
          >Petunjuk dan Langkah-langkah Mengikuti Psikotes Online</div>
          <p style="margin-top:10px;margin-left:20px;margin-right:5px;"></p>
          <ol class="title" style="margin-left:20px;">
            <li>
              Kesiapan dan persyaratan Pretest Psikologi (Sebelum Mengikuti Psikotes)
              <ol type="a" class="body-1">
                <li
                  style="margin-top: 5px;"
                >Klien diharapkan memiliki kesiapan mental yang baik, diantaranya mempunyai kesungguhan, semangat, memiliki tujuan kebutuhan yang diharapkan, mempersiapkan emosi yang tenang dengan adanya rasa suka cita, gembira serta tanpa paksaan dan keyakinan dalam mengerjakan soal, dll.</li>
                <li
                  style="margin-top: 5px;"
                >Klien tidak memiliki beban tugas yang besar dan tidak memiliki masalah yang besar.</li>
                <li
                  style="margin-top: 5px;"
                >Klien diharapkan memiliki kondisi fisik yang baik, diantaranya sehat atau kondisi tubuh fit, sudah makan, istirahat yang cukup dll.</li>
                <li
                  style="margin-top: 5px;"
                >Klien perlu dukungan dan motivasi dari faktor eksternal (lingkungan sekitarnya termasuk lingkungan keluarga, rekan kerja, sahabat).</li>
                <li
                  style="margin-top: 5px;"
                >Faktor eksternal tidak menimbulkan masalah besar terhadap klien disaat akan mengikuti psikotest berlangsung.</li>
                <li style="margin-top: 5px;">
                  H-1 psikotest online klien
                  <span style="font-weight:bold;">WAJIB</span> mempersiapkan perlengkapan untuk mengikuti psikotest online dengan baik. Misalnya sediakan laptop/handphone serta kuota yang cukup untuk mengakses psikotest online.
                </li>
              </ol>
            </li>

            <li style="margin-top:20px;">
              Saat Psikotes Berjalan atau Berlangsung
              <ol type="a" class="body-1">
                <li
                  style="margin-top: 5px;"
                >Klien sudah mempersiapkan perlengkapan untuk mengikuti psikotest online, diantaranya bisa menggunakan laptop, handphone dan juga tersedianya kuota yang cukup/wifi/batree handphone atau laptop yang cukup.</li>
                <li
                  style="margin-top: 5px;"
                >Program psikotest online yang dikerjakan klien alangkah baiknya dilakukan di sekolah/instansi secara serempak/klasikal. Tetapi dikarenakan permasalahan bencana/wabah pandemi covid-19 bisa juga dilakukan secara perorangan seperti psikotest-individual yang bisa dilakukan dimana saja (rumah, kantor,dll) yang terpenting dalam kerjanya sungguh-2, memenuhi protokol instruksi psikotes.</li>
                <li style="margin-top: 5px;">
                  Klien harus mempersiapkan kode browsing, username dan password guna membuka program psikotest online yang sudah diberikan pihak lembaga psikologi/pihak sekolah/pihak instansi. Kemudian lakukan memasukkan kode browsing setelah membuka lanjutkan masukkan username dan password baru selanjutnya tekan “
                  <span
                    style="font-weight:bold;"
                  >LOGIN</span>” kalau ada tampilan permintaan “save” di
                  laptop/HP maka lakukan tekan save dengan tujuan username dan password sudah tersimpan dan klien tidak melakukan pengetikan ulang username dan password.
                </li>
                <li
                  style="margin-top: 5px;"
                >Bila klien bisa membuka program psikotest online, alangkah baiknya jika dibuka sendiri, diisi/ dikerjakan secara mandiri. Apabila klien tidak bisa membuka dan mengoperasionalkan program psikotest online bisa dibantu orang terdekat, misalnya orangtua, saudara, dll. Tetapi tidak diperkenankan membantu mengerjakan maupun memberikan jawaban psikotest. (Hanya sebatas membantu dalam mengoperasionalkan program psikotest online).</li>
                <li style="margin-top: 5px;">
                  Klien diharapkan mengikuti dan memperhatikan petunjuk-petunjuk pengerjaan psikotest secara urut sesuai langkah-langkah diantaranya :
                  <ol>
                    <li style="margin-top: 5px;">
                      Klien
                      <span style="font-weight:bold;">WAJIB</span> perlu mengisi biodata lengkap/identitas klien : isi nomor tes/nomor induk, isi nama lengkap, isi tanggal lahir ( klik tahun, klik bulan, klik tanggal ), isi pendidikan/sekolah, isi kelas, memberi foto pribadi bila perlu, selanjudnya “
                      <span
                        style="color:blue;font-weight:bold;"
                      >SAVE</span>” bisa di edit kalau ada kekeliruan.
                    </li>
                    <li
                      style="margin-top: 5px;"
                    >Klien WAJIB membaca informasi psikologi secara detail dan klien WAJIB mengisi informed consent atau persetujuan mengikuti program psikotest online.</li>
                  </ol>
                </li>
                <li
                  style="margin-top: 5px;"
                >Langkah selanjutnya klien WAJIB mengambil paket psikotest online dalam program yang diberi kesempatan satu kali pengambilan. Isi dalam paket psikotest online tersebut mencakup full test sesuai dengan kebutuhan yang diharapkan klien dan pihak-pihak yang bersangkutan.</li>
                <li style="margin-top: 5px;">
                  Klien mengambil paket psikotest terdapat beberapa sub aspek psikotest yang
                  <span
                    style="font-weight:bold;"
                  >WAJIB</span> dipilih semua dan dikerjakan sesuai keinginan pilihan klien. Dengan mengambil satu-persatu sub aspek psikotest, klien memilih dan mengklik tanda “
                  <span
                    style="font-weight:bold;color:blue;"
                  >START</span>”. Saat membuka start klien perlu membaca petunjuk/instruksi dan cara mengerjakan selanjutnya psikotes dimulai dengan diberi tanda waktu test, kemudian kerjakan secepatnya, secermatnya dan seteliti mungkin. Setiap soal baca lebih detail dan pilih jawaban dengan memberi tanda klik dijawaban yang dipilih dan dianggap benar/sesuai bila salah/kliru bisa dikoreksi ulang next mundur, kalau pass bisa tekan tombol next maju. Apakah soal bisa dilompati “bisa” dan perlu melihat tombol isian jawaban yang kosong bisa mengunakan next maju atau mundur, juga tekan tombol nomor di bagian atas soal ada rentang nomor 1, 2, 3 ……..dst.
                </li>
                <li style="margin-top: 5px;">
                  Jika sub aspek psikotest sudah dikerjakan oleh klien dengan : waktu tepat soal sudah selesai, waktu masih ada dan sudah selesai yakin jawabannya benar maka tekan tombol “
                  <span style="font-weight: bold;color:blue;">FINISH</span>” maka muncul tanda “
                  <span style="font-weight:bold;color:green;">COMPLETED</span>”, akan tetapi saat mengerjakan soal klien mengalami kesulitan dan memakan waktu/waktu habis dengan soal masih ada maka akan berhenti otomatis dan dinyatakan “
                  <span style="font-weight:bold;color:green;">COMPLETED</span>”.
                  <br />
                  <span class="title">Permasalahan yang perlu diperhatikan :</span>
                  <ol>
                    <li style="margin-top: 5px;">
                      Bilamana klien berhalangan saat psikotes online berjalan tepatnya di saat mengerjakan soal misalnya : sakit perut/pusing/ijin kebelakang tetap diperbolehkan tetapi tekan tombol “
                      <span style="font-weight:bold;">PAUSE</span>” supaya waktunya tidak berjalan terus, baru setelah itu tekan “
                      <span style="font-weight:bold;color:blue;">RESUME</span>” untuk mulai lagi sampai waktunya habis. Kemudian seterusnya ambil sub aspek psikotest dengan proses pengerjaan yang sama, hingga selesai semua.
                    </li>
                    <li style="margin-top: 5px;">
                      Bilamana dikarenakan sesuatu hal disaat mengerjakan soal-soal psikotest online berjalan tiba-tiba terganggu misalnya listrik mati, jaringan internet/wifi terganggu, kuota habis,dll. psikotes online bisa diulang kembali dan yang sudah dikerjakan tidak hilang bisa tekan “
                      <span style="font-weight:bold;">RESUME</span>” atau saat mengerjakan soal terakhir akan muncul secara otomatis maka langsung kerjakan sampai waktunya habis. Kemudian seterusnya ambil sub aspek psikotest dengan proses pengerjaan yang sama, hingga selesai semua.
                    </li>
                  </ol>
                </li>
                <li
                  style="margin-top: 5px;"
                >Klien diharapkan mampu mengerjakan psikotest online dengan sungguh-sungguh, secara mandiri dan tidak mencontek atau open book/searching/meminta bantuan dari orang lain. Bila mana ada pihak lain yang berupaya membantu, memberi jawaban, bahkan membantu mengerjakan sepenuhnya akan menimbulkan dan memunculkan hasil psikotest online kurang valid dan terkesan tidak memberi kepuasan pada siapapun dikarenakan hasil psikotest online tidak bisa mewakili kemampuan atau potensi, karakter kepribadian serta bakat minat klien secara baik dan benar.</li>
                <li
                  style="margin-top: 5px;"
                >Klien harus memperhatikan petunjuk intruksi yang benar dan memperhatikan waktu yang diberikan dalam mengerjakan dikarenakan waktunya singkat sekali/ terbatas.</li>
                <li style="margin-top: 5px;">
                  Klien diberi waktu psikotest online dalam
                  <span style="font-weight:bold;">expired waktu 24 jam</span>. Jika tidak digunakan maka username dan password akan hangus dan tidak bisa digunakan kembali. Bilamana klien ingin melakukan psikotest online ulang.
                </li>
                <li style="margin-top: 5px;">
                  Maka klien harus
                  <span style="font-weight:bold;">WAJIB</span> mendaftar atau registrasi dengan menghubungi pihak sekolah/instansi/ pihak lembaga psikotest online “
                  <span style="font-weight:bold;">Yayasan Psikologi Pelita Multi Talenta</span>” Kantor Operasional dengan No.Telp (0341) 4382861 – (0341) 414636 atau No.Handphone 081233332935.
                </li>
              </ol>
            </li>
            <li  style="margin-top:20px;">Postes Psikologi</li>
            <ol class="body-1" type="a"> 
                <li style="margin-top: 5px;">
                    Hasil psikotest yang dikerjakan secara online dapat mewakili dan memberikan profil keberadaan potensi atau kemampuan dalam diri klien sesungguhnya secara kongkrit, valid dan benar. Apabila hasil psikotest online tidak mewakili profil klien, maka perlu dipertanyakan saat mengerjakan psikotest online apakah klien didalam mengerjakan dengan sungguh-sungguh dan jelas pada materi yang dikerjakan atau apakah ada campur tangan dari pihak orang lain yang sifatnya mempengaruhi (misalnya membentak, memarahi, menyalahkan, memojokan, mengejek, dll), membantu (misalnya memberi jawaban benar atau salah, mengerjakan sepenuhnya, dll), serta apakah ada pengaruh kondisi psikotest online yang dipaksakan secara fisik dan psikis klien disaat mengerjakan (misalnya kondisi sakit perut, pusing, dihantui perasaan takut dan cemas, menarget hasil, diancam, ditekan, dibentak, dll).
                </li>
                 <li style="margin-top: 5px;">
                     Hasil psikotest akan dikeluarkan dan dibagikan setelah klien menyelesaikan psikotest online dan diberitaukan kepada pihak sekolah setelah itu akan diberitaukan kepada orangtua/wali/pihak yang berkepentingan.
                 </li>
                 <li style="margin-top: 5px;">
                     Hasil psikotest yang diterima klien tidak ada kaitannya dengan nilai akademik atau nilai persyaratan untuk kenaikan/kenaikan posisi,dll. tetapi perlu digaris bawahi bahwa “<span style="font-weight:bold;">Hasil psikotes akan digunakan untuk melihat nilai potensi kelebihan dan  kekurangan klien dalam hal ini dipakai untuk membuat  pola bimbingan, pola penyaluran dan pola pelatihan yang cocok/sesuai kebutuhan masing-masing klien </span>” Hasil psikotest dilihat dari :
                     <ol>
                         <li style="margin-top: 5px;">
                             Nilai kelebihan klien yang harus dilatih dan dikembangkan supaya klien lebih maju dan berpotensi tinggi dalam mengembangkan dan mengunakan inteligensi, bakat-minat dan karakter positifnya.
                         </li>
                          <li style="margin-top: 5px;">
                              Nilai kekurangan/kelemahan klien yang menjadikan permasalahan dan menghambat prestasi klien harus mendapatkan bimbingan, arahan yang tepat untuk mencari solusi penyelesaian masalah klien di saat memberi konseling dan terapis.
                          </li>

                     </ol>
                 </li>
                 <li style="margin-top: 5px;">
                     Hasil psikotest akan ditindak lanjuti dengan memberikan ceramah dan penjelasan hasil psikotest online melalui program via daring. Demikian juga kesempatan berkonsultasi dengan pihak psikolog juga melalui program via daring. Jadwal program via daring akan disampaikan melalui sekolah lewat WhatsApp Group. 
                 </li>

            </ol>
          </ol>
        </v-flex>
      </v-layout>

      <v-layout >
          <v-flex class="text-sm-center">
              <span class="display-2" style="color: #B71C1C;"  >WARNING</span>                            
          </v-flex>
      </v-layout>
      <v-layout>
          <v-flex>
              <ol class="body-1" style="margin-left: 20px;">
                  <li style="margin-top: 5px;">
                      Siapkan perlengkapan dibutuhkan psikotest online secara baik.
                  </li>
                  <li style="margin-top: 5px;">
                      Kondisikan fisik dan psikis secara maksimal.
                  </li>
                  <li style="margin-top: 5px;">
                      Kerjakan psikotest online ini dengan sungguh-sungguh.
                  </li>
                  <li style="margin-top: 5px;">
                      Kerjakan psikotest online secara mandiri.
                  </li>
                   <li style="margin-top: 5px;">
                      Tidak boleh dibantu dalam mengerjakan psikotest online.
                  </li>
                   <li style="margin-top: 5px;">
                      Perhatikan time atau waktu saat proses mengerjakan psikotest online.
                  </li>
                   <li style="margin-top: 5px;">
                      Perhatikan <span style="font-weight: bold;">waktu Expired psikotest online</span>.
                  </li>


              </ol>
          </v-flex>
      </v-layout>
      <v-layout>
          <v-flex style="height: 40px;" >
          </v-flex>
      </v-layout> 
    </v-container>
  </div>
</template>
<script>
export default {
  name: "psiko-petunjuk-dan-informasi",
  data() {
    return {};
  },
  filters: {
    date: function(value) {
      return format(new Date(value), "DD-MM-YYYY");
    }
  },
  mounted() {},
  methods: {}
};
</script>